export function trackEvent(vm, name, category, label, customData = {}) {
  if (!vm || !vm.$gtag) {
    console.warn('Google Analytics is not available.')
    return
  }

  vm.$gtag.event(name, {
    event_category: category,
    event_label: label,
    ...customData
  })
}
